import { defaultStyles } from '@visx/tooltip';

import { StudioVisualizationType } from '@blockworks/platform/api/research/studio';

import { GetVisualizationPropsResponse } from '../../../models';

type PieProps = GetVisualizationPropsResponse<StudioVisualizationType.Pie>;

type PieTooltipData = {
    label: string;
    percentage: string;
    value: number;
    format?: string;
};

const TOOLTIP_STYLES = {
    ...defaultStyles,
    padding: '8px',
    borderRadius: '8px',
    width: 152,
    height: 72,
};

export type { PieProps, PieTooltipData };
export { TOOLTIP_STYLES };
